"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { getFieldSchemaFromValue, getFieldSchemaOptions } from './data-field.mjs';
import { DataBuilderFieldContext } from './use-data-builder-field.mjs';

const DataBuilderFieldProvider = ({ field, children }) => {
  const [localSchema, setLocalSchema] = useState(() => getDefaultLocalSchema(field));
  function resetLocalSchema() {
    setLocalSchema(getDefaultLocalSchema(field));
  }
  const [localSchemaChangedManually, setLocalSchemaChangedManually] = useState(false);
  const [autoOpen, setAutoOpen] = useState(false);
  return /* @__PURE__ */ jsx(
    DataBuilderFieldContext.Provider,
    {
      value: {
        field,
        localSchema,
        setLocalSchema,
        resetLocalSchema,
        localSchemaChangedManually,
        setLocalSchemaChangedManually,
        autoOpen,
        setAutoOpen
      },
      children
    }
  );
};
function getDefaultLocalSchema(field) {
  const fieldSchemaFromValue = getFieldSchemaFromValue(field);
  const fieldSchemaOptions = getFieldSchemaOptions(field);
  if (field?.schema) {
    if (!field?.schema?.type) {
      return fieldSchemaFromValue || {
        ...field.schema,
        type: fieldSchemaOptions[0].type
      };
    }
    if (Array.isArray(field.schema.type)) {
      return fieldSchemaFromValue || {
        ...field.schema,
        type: field.schema.type[0]
      };
    }
    return field.schema;
  }
  return fieldSchemaFromValue || {
    type: fieldSchemaOptions[0].type
  };
}

export { DataBuilderFieldProvider };
